var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-autocomplete',{style:({width: _vm.width}),attrs:{"fetch-suggestions":_vm.querySearchAsync,"placeholder":_vm.placeholder,"size":_vm.size},on:{"input":_vm.handleChange},model:{value:(_vm.autoValue),callback:function ($$v) {_vm.autoValue=$$v},expression:"autoValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }